/**
 * Holds the active School **slug** so the axios client attaches it to every
 * request. Tenancy is carried by the `X-School` header, separate from the JWT
 * (which only authenticates the user).
 *
 * Confirmed against the Osvitly `CurrentSchoolMiddleware`
 * (osvitly/apps/schools/middleware.py): header name is `X-School` and the
 * value is the school **slug** (it resolves `School.objects.filter(slug=…)`),
 * not the id.
 *
 * The UI's school switcher (client state) is the writer; the axios request
 * interceptor is the reader. When the active school changes, also invalidate
 * school-scoped queries (the switcher calls `queryClient.clear()`).
 */

export const SCHOOL_HEADER = 'X-School';

let activeSchoolSlug: string | null = null;

export const schoolContext = {
  get(): string | null {
    return activeSchoolSlug;
  },
  set(slug: string | null): void {
    activeSchoolSlug = slug;
  },
};
